import React from 'react';
import { mobileCombustion } from '../../../Pages/Questionnaire/directEmission';
import {
  StyledHeader,
  StyledTd,
} from '../../../Pages/Questionnaire/index.styles';
import { companiesColors } from '../../../Pages/SuperDashboard/data';
import { useTranslation } from 'react-i18next';
import CommentBtn from './commentBtn';
import TableButton from '../../TableButton';
import { toLocaleNumber } from '../../../../utils/helpers';

interface Props extends mobileCombustion {
  emission_shared: number;
}

export default function MobileCombustionPreview({
  state,
  id,
  setActive,
  setState,
  language,
}: {
  state: Props[];
  id: number;
  setActive: Function;
  setState: Function;
  language: string;
}) {
  const { t } = useTranslation();
  const handleCopy = () => {
    const tempState = [...state];
    const item = tempState[id];

    tempState.splice(id, 0, item);
    setState(tempState);
    setActive(id);
  };
  return (
    <StyledHeader>
      <StyledTd width={20} color={companiesColors[id]}>
        {state[id].name_of_equipement}
      </StyledTd>
      <StyledTd width={20} color={companiesColors[id]}>
        <p>{t(`dropdowns.${state[id].type_of_fuel}`)}</p>
        <CommentBtn state={state} id={id} />
      </StyledTd>
      <StyledTd width={20} color={companiesColors[id]}>
        {toLocaleNumber(state[id].amount_per_period, language)}
      </StyledTd>
      <StyledTd width={10} color={companiesColors[id]}>
        {t(`dropdowns.${state[id].unit_of_fuel}`)}
      </StyledTd>
      <StyledTd width={16} color={companiesColors[id]}>
        {state[id].distance_travelled ?? ''}
      </StyledTd>
      <StyledTd width={13} color={companiesColors[id]}>
        {state[id].emission_shared
          ? (state[id].emission_shared * 100).toFixed(2)
          : 0}
      </StyledTd>
      <StyledTd width={0} color={companiesColors[id]} numberOfIcons="two">
        <TableButton hoverText="copy" icon="copy" onClick={handleCopy} />
        <TableButton
          hoverText="edit"
          icon="edit"
          onClick={() => setActive(id)}
        />
      </StyledTd>
    </StyledHeader>
  );
}
